import gql from 'graphql-tag';
import S3Object from './s3_object';

export default gql`
  fragment ProfileSuggestion on ProfileSuggestion {
    id
    title
    image {
      ...S3Object
    }
  }
  ${S3Object}
`;
